/**
 * Trunca un número a una cantidad fija de decimales sin redondear
 * @param {number} value - Valor numérico a truncar
 * @param {number} decimals - Cantidad de decimales
 * @returns {string} - Valor truncado como string
 */
function truncateToDecimals(value, decimals) {
  const factor = Math.pow(10, decimals);
  return (Math.round(value * factor) / factor).toFixed(decimals);
}

function formatNumber(value) {
  // Remove the euro symbol and any spaces
  let clean = value.replace('€', '').trim();
  // Remove the decimal point
  clean = clean.replace('.', '');
  // Convert to number
  return parseInt(clean, 10);
}

/**
 * Escucha cambios de selección de volumen para actualizar precios en la interfaz
 */
document.addEventListener("input:volume-tier", (e) => {
  /**
   * Helpers globales para manipulación de precios en la UI
  */
  const priceElements = document.querySelector('[data-price-event-private]'); //precio principal privado
  const priceElementsBusiness = document.querySelector('[data-price-event-business]'); //precio principal business
  const pricePreunitElements = document.querySelector('[data-price-preunit-event-private]'); //precio por unidad privado
  const pricePreunitElementsBusiness = document.querySelector('[data-price-preunit-event-business]'); //precio por unidad business
  
  const labelBoxSingular = e.detail.labelBoxSingular;
  const iva = e.detail.iva;
  const dataPrice = truncateToDecimals(parseFloat(e.detail.dataPrice) * (1 + iva / 100), 2);
  const dataPreunit = truncateToDecimals(parseFloat(e.detail.dataPreunit) * (1 + iva / 100), 2);
  const dataPriceBusiness = e.detail.dataPrice;
  const dataPreunitBusiness = e.detail.dataPreunit;

  if (priceElements) priceElements.textContent = `${dataPrice}€/${labelBoxSingular}`;
  if (pricePreunitElements) pricePreunitElements.textContent = pricePreunitElements.classList.contains('alternative') ? `${dataPreunit}€/Und.` : `(${dataPreunit}€/Und.)`;
  if (priceElementsBusiness) priceElementsBusiness.textContent = `${dataPriceBusiness}/${labelBoxSingular}`;
  if (pricePreunitElementsBusiness) pricePreunitElementsBusiness.textContent = pricePreunitElementsBusiness.classList.contains('alternative') ? `${dataPreunitBusiness}€/Und.` : `(${dataPreunitBusiness}€/Und.)`;

  // Precio por kilo (<price-per-type>): si el producto tiene <bundler-volume-price>, lo
  // controla ese componente (para que coincida con el "Desde" fijo / el precio aplicado en
  // carrito), así que aquí NO se toca. Si NO hay bvp (p. ej. producto con volume-selector
  // pero sin el tag "volumen"), se mantiene el comportamiento anterior: el €/Kilo sigue el
  // tramo seleccionado.
  const hasBvp = document.querySelector(`bundler-volume-price[data-product-id="${e.detail.productId}"]`);
  if (!hasBvp) {
    document.querySelectorAll(`.c-product__details [data-product-type="${e.detail.productId}"]`).forEach((item) => {
      item.changePriceForType(formatNumber(dataPrice), formatNumber(dataPriceBusiness));
    });
  }
});

/**
 * Componente CustomSelect para selects personalizados accesibles
 */
class CustomSelect extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector('[data-trigger]');
    this.list = this.querySelector('[data-list]');
    this.toggleList();
  }
  toggleList() {
    this.trigger.addEventListener('click', () => {
      this.trigger.classList.toggle('open');
    });
  }
}
customElements.define('custom-select', CustomSelect);

/**
 * Controlador de selección de volumen y precios dinámicos
 * Gestiona el flujo de selección de cantidad, integración con Bundler y lógica de carrito
 */
class VolumeTierSelectorController extends HTMLElement {
  /**
   * Constructor
   */
  constructor() {
    super();
    this.template = document.getElementById('tier-template');
    this.labelTypeSingular = this.getAttribute('data-label-box-singular');
    this.labelTypePlural = this.getAttribute('data-label-box-plural');
    this.ITEMS_PER_BOX = this.getAttribute('data-unit-per-type') || 0;
    this.labelUnitsPer = this.getAttribute('data-label-units-per');
    this.labelDiscount = this.getAttribute('data-label-discount');
    this.iva = this.getAttribute('data-iva');
    this.cartQty = this.getAttribute('data-cart-quantity');
    this.stockQty = this.getAttribute('data-stock');
    this.customerType = window.localStorage.getItem('ls.biribox.view-type');
  }

  /**
   * Lifecycle: connectedCallback
   */
  connectedCallback() {
    this.init()
console.log('CART:REFRESH 14')
    document.addEventListener('cart:updated', () => {
      this.checkItemsInCart();
    });

    /* document.addEventListener('cart:refresh', () => {
      const sectionData = this.getAttribute('data-section');
      const sectionId = sectionData.replace('volume-', '');
      const volumeSelector = document.querySelector(`[data-section="${sectionData}"]`);
      


    const url = new URL(window.location.href);         // conserva pathname + query + hash
    url.searchParams.set('sections', sectionId);       // añade/sobrescribe solo "sections"

    fetch(url.toString())
      .then(res => res.json())
      .then(data => {
        const tmpMainSection = document.createElement('div');
        tmpMainSection.innerHTML = data[sectionId];

        const newVolumeTier = tmpMainSection.querySelector(`#pb-product-info`);
      const oldVolumeTier = document.querySelector(`#pb-product-info`);
      console.log(newVolumeTier, 'new');
      console.log(oldVolumeTier);
      if (newVolumeTier && oldVolumeTier) {
        oldVolumeTier.replaceWith(newVolumeTier);
      }

          console.log(tmpMainSection, 'tmpMainSection')
        })
        .catch(error => {
          console.error('Error al cargar la sección:', error);
        });


      //volumeSelector.init();
    }); */

    document.addEventListener('custom-type:change', (e) => {
      this.customerType = e.detail.customerType;
      this.changePriceForType();
    });
  }

  /**
   * Lifecycle: disconnectedCallback
   * Limpia el polling a Bundler si el elemento se desconecta mientras Bundler aún carga
   * (p. ej. al cerrar el pop-up o al re-renderizarse la sección), para no dejar el intervalo
   * (hasta ~30s) disparándose contra un elemento ya separado del DOM.
   */
  disconnectedCallback() {
    if (this.bundlerPollInterval) {
      clearInterval(this.bundlerPollInterval);
      this.bundlerPollInterval = null;
    }
  }

  init(){
    this.initElements();
    this.bindEvents();
    this.getBundlerDiscounts();
    this.checkItemsInCart();
  }

  /**
   * Inicializa elementos internos del componente
   */
  initElements() {
    this.price = parseFloat(this.getAttribute('data-product-price').replace(',', '.'));
    this.form = this.querySelector('#volume-form');
    this.variantId = this.form.querySelector('input[name="id"]').value;
    this.productId = this.form.querySelector('input[name="id"]').getAttribute('data-product-id');
    this.loading = this.querySelector('.volume-tier__loading');
    this.button = this.querySelector('.volume-tier__button');
    this.containerQuantity = this.querySelector('.volume-tier__quantity');
    this.containerError = this.querySelector('.volume-tier__error');
  }

  /**
   * Asocia eventos al formulario y radios
   */
  bindEvents() {
    this.form.addEventListener('submit', (e) => {
      e.preventDefault();
      this.addToCart();
    });

    this.form.addEventListener('change', (e) => {
      // Solo procesar cambios en los radio buttons de volume-tier
      if (e.target.type !== 'radio' || e.target.name !== 'volume-tier') return;
      
      const { value, dataset } = e.target;
      const { price, preunit } = dataset;

      // Si es cliente tipo business, usar precio sin IVA
      // Si es cliente privado, aplicar IVA al precio
      // value = cantidad del tramo (min_items) → la usa <bundler-volume-price> para mostrar
      // el precio del tramo seleccionado.

      this.handleEventRadioInput(price, preunit, this.iva, value);
    });
  }

  /**
   * Dispara un evento personalizado cuando se selecciona un radio
   */
  handleEventRadioInput(dataPrice, dataPreunit, iva, quantity) {
    this.dispatchEvent(new CustomEvent("input:volume-tier", {
      detail: {dataPrice, dataPreunit, iva, quantity, labelBoxSingular: this.labelTypeSingular, productId: this.productId },
      bubbles: true,
      composed: true
    }));
  }

  /**
   * handleTierRefreshEvent
   */

  handleTierRefreshEvent(){
    this.dispatchEvent(new CustomEvent("tier:refresh", {
      bubbles: true,
      composed: true
    }));
  }

  /**
   * Agrega el producto al carrito
   */
  /**
   * Añade productos al carrito con manejo de cantidades existentes
   */
  addToCart() {
    // Mostrar estado de carga
    this.loading.classList.add('loading--active');
    
    // Validar selección
    const selectedOption = this.querySelector('input[name="volume-tier"]:checked');
    if (!selectedOption) {
      this.showError('No se ha seleccionado una opción');
      return;
    }

    const quantity = parseInt(selectedOption.value);
    
    // Ocultar mensajes de error anteriores
    this.containerError.classList.add('hidden');
    
    // Función para manejar errores de forma consistente
    const handleError = (error) => {
      const errorMessage = error?.message || 'Error al añadir al carrito';
      this.showError(errorMessage);
      console.error('Error en operación de carrito:', error);
      document.dispatchEvent(new CustomEvent('cart:errorAddItem'));
      console.log('CART:REFRESH 7')
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    };
    
    // Función para procesar respuestas HTTP
    const processResponse = (response) => {
      if (!response.ok) {
        return response.json().then(errorData => {
          throw new Error(errorData.description || errorData.message || `Error ${response.status}`);
        });
      }
      return response.json();
    };
    
    // Verificar si el producto ya existe en el carrito
    fetch('/cart.js')
      .then(processResponse)
      .then(cart => {
        // Buscar si el producto ya existe
        const existingItem = cart.items.find(item => 
          item.variant_id == this.variantId || item.id == this.variantId
        );

        // Preparar FormData para la solicitud
        const formData = new FormData();
        
        if (existingItem) {
          // Actualizar cantidad si el producto ya existe
          const newQuantity = existingItem.quantity + quantity;
          formData.append('id', existingItem.id);
          formData.append('quantity', newQuantity);
          
          return fetch('/cart/change.js', {
            method: 'POST',
            body: formData
          });
        } else {
          // Añadir nuevo producto
          formData.append('id', this.variantId);
          formData.append('quantity', quantity);
          
          return fetch('/cart/add.js', {
            method: 'POST',
            body: formData
          });
        }
      })
      .then(processResponse)
      .then(data => {
        // Notificar a otros componentes sobre la actualización
        /* const cart = document.querySelector('cart-drawer');
        if(cart){
          cart.updateCart();
        } */
        
          console.log('CART:REFRESH 8', )
        document.dispatchEvent(new CustomEvent('cart:refresh', {detail: {variantId: this.variantId}}));

        //document.dispatchEvent(new CustomEvent('cart:data-refresh'));
        
        // Procesar la respuesta
        this.handleAddToCartResponse(data);
      })
      .catch(handleError);
  }
  
  /**
   * Muestra un mensaje de error y oculta el estado de carga
   */
  showError(message) {
    this.containerError.textContent = message;
    this.containerError.classList.remove('hidden');
    this.loading.classList.remove('loading--active');
  }

  /**
   * Maneja la respuesta al agregar al carrito
   */
  handleAddToCartResponse(data) {
    this.loading.classList.remove('loading--active');
    if (data?.message) {
      console.table('error', data)
      this.containerError.textContent = data.message;
    this.containerError.classList.remove('hidden');
    } else {
      this.containerError.classList.add('hidden');
      this.checkItemsInCart();
      window.showToast(window.globalTranslations.addToCart);
    }

    this.handleTierRefreshEvent();
  }

  /**
   * Consulta el carrito actual
   */
  checkItemsInCart() {
    setTimeout(() => {   
      fetch('/cart.js', {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      })
        .then(response => response.json())
        .then(data => this.processCartData(data))
        .catch(error => console.error('Error al obtener el carrito:', error));
    }, 500);
  }

  /**
   * Procesa la información del carrito para mostrar cantidad y descuentos
   */
  processCartData(data) {
    if (!data?.items) return;

    const matchingItems = data.items.filter(item => item.id == this.variantId);
    if (matchingItems.length === 0) {
      this.containerQuantity.classList.add('hidden');
      return;
    }

    const totalQuantity = matchingItems.reduce((sum, item) => sum + item.quantity, 0);

    let totalOriginalPrice = 0;
    let totalFinalPrice = 0;

    matchingItems.forEach(item => {
      totalOriginalPrice += item.original_line_price / 100;
      totalFinalPrice += item.final_line_price / 100;
    });

    const totalSaved = (totalOriginalPrice - totalFinalPrice).toFixed(2);
    const discountPercentage = totalOriginalPrice > 0
      ? Math.round((totalSaved / totalOriginalPrice) * 100)
      : 0;

    this.updateQuantityDisplay(totalQuantity, totalSaved, discountPercentage);
    this.containerQuantity.classList.remove('hidden');
  }

  /**
   * Muestra en pantalla la cantidad y el descuento actual
   */
  updateQuantityDisplay(quantity, totalSaved, discountPercentage) {
    const qtyElement = this.containerQuantity.querySelector('.qty');

    if (!qtyElement) {
      let messageTemplate = this.containerQuantity.textContent;
      this.containerQuantity.innerHTML = messageTemplate
        .replace('[quantity]', `<span class="qty">${quantity} ${(quantity === 1 ? this.labelTypeSingular : this.labelTypePlural)}</span>`)
        .replace('[discount_value]', `<span class="discount-value" data-value="${totalSaved}">${totalSaved}€</span>`);
    } else {
      qtyElement.textContent = `${quantity} ${(quantity === 1 ? this.labelTypeSingular : this.labelTypePlural)}`;
      /* this.containerQuantity.querySelector('.discount-value').textContent = `${totalSaved}€`; */
      this.containerQuantity.querySelector('.discount-value').dataset.value = totalSaved;
      this.changePriceForType()
    }
  }

  /**
   * Lógica de integración con la app Bundler.
   * Bundler (bundler-script.js + su config) puede tardar varios segundos en cargar en un
   * primer acceso sin caché, más que el JS del tema. Reintentamos mientras Bundler siga
   * cargando (con un tope de seguridad amplio) para no dejar el selector sin construir por
   * una condición de carrera; antes solo se esperaba ~5s y a veces no llegaba a tiempo.
   */
  getBundlerDiscounts() {
    if (this.tryGetBundles()) return;

    let attempts = 0;
    const maxAttempts = 60;
    this.bundlerPollInterval = setInterval(() => {
      attempts++;
      if (this.tryGetBundles() || attempts >= maxAttempts) {
        clearInterval(this.bundlerPollInterval);
        this.bundlerPollInterval = null;
      }
    }, 500);
  }

  /**
   * Intenta construir el selector con los bundles activos.
   * Devuelve true cuando la decisión es definitiva (se construyó, o el producto no está en
   * ningún bundle con Bundler ya cargado); false si Bundler aún está cargando y hay que
   * reintentar.
   */
  tryGetBundles() {
    if (typeof window.bndlr === 'undefined' || typeof window.bndlr.getBundles !== 'function') {
      return false; // Bundler aún no ha cargado
    }

    const bundles = window.bndlr.getBundles();
    if (!bundles || !bundles.length) return false; // datos aún no disponibles

    const sortedBundles = [...bundles].sort((a, b) => (a.priority || 999) - (b.priority || 999));
    const matchingBundle = sortedBundles.find(bundle => bundle.products && bundle.products[this.productId]);

    if (matchingBundle) {
      const built = this.buildSelector([matchingBundle]);
      if (built) this.classList.remove('hidden');
      return true;
    }

    // Sin bundle para el producto: definitivo solo si Bundler ya terminó de cargar.
    return window.bundlerLoaded2 === true;
  }

  // Construye el selector visual de niveles de volumen.
  // Devuelve true si lo construyó (y hay que mostrarlo); false en caso contrario.
  buildSelector(bundle) {
    // Si el producto ya está en el carrito, no construimos el selector de volumen:
    // dejamos visibles los botones normales de la PDP (.tier-handle), que muestran el
    // stepper de cantidad. Así, al añadir cualquier cantidad, la PDP pasa directa al
    // stepper en lugar de re-mostrar tramos filtrados por el stock restante.
    if (parseInt(this.cartQty, 10) > 0) return false;

    const volumeDiscounts = bundle[0]?.volume_discounts;

    if (!Array.isArray(volumeDiscounts)) {
      console.warn('No volume_discounts found in bundle');
      return false;
    }

    const totalElements = volumeDiscounts.length;
    const tierElements = volumeDiscounts
      .map((discount, index) => this.createTierElement(discount, index, totalElements))
      .filter(Boolean); // quita undefined, null, false, 0, ''

    if (tierElements.length > 1) {
      this.form.prepend(...tierElements);
      this.changePriceForType();
      this.preselectHighestTier();
      document.querySelector('.tier-handle').classList.add('hidden');
      this.button.classList.remove('hidden');
      return true;
    }
    return false;
  }

  /**
   * Preselecciona por defecto el tramo de mayor cantidad (el más económico por unidad,
   * el que corresponde al precio "Desde" de la card).
   * createTierElement() ya descarta los tramos que superan el stock disponible, así que
   * "el mayor de los visibles" es el mayor alcanzable: si no hay stock para el tramo más
   * alto (p. ej. 12), queda seleccionado el siguiente disponible (p. ej. 6).
   */
  preselectHighestTier() {
    const radios = this.form.querySelectorAll('input[name="volume-tier"]');
    if (!radios.length) return;

    let highest = radios[0];
    radios.forEach((radio) => {
      radio.checked = false;
      if (parseInt(radio.value, 10) > parseInt(highest.value, 10)) highest = radio;
    });
    highest.checked = true;
  }

  // Crea cada input radio para un tier
  createTierElement(discount, index, totalElements) {

    if(discount.min_items > this.stockQty || discount.min_items > (this.stockQty - this.cartQty)) return;

    const node = this.template.content.cloneNode(true);
    const $ = selector => node.querySelector(selector);

    /*
      discount.discount_value: devuelve el porcentaje que el app aplica como descuento ejemplo: "10"
      o "" si no hay descuento.
    */
    const discountedPrice = parseFloat(this.calculateDiscountedPrice(discount.discount_value));
    const price = `${discountedPrice.toFixed(2)}€`;
    const totalUnits = discount.min_items * parseInt(this.ITEMS_PER_BOX);
    let unitPrice = '';

    if (totalUnits > 0) {
      const division = discountedPrice / parseInt(this.ITEMS_PER_BOX);
      unitPrice = Math.round(division * 100) / 100;
      unitPrice = unitPrice.toFixed(2);
    }

    const input = $('input');
    input.value = discount.min_items;
    input.dataset.price = price;
    input.dataset.preunit = unitPrice;
    // La preselección se centraliza en preselectHighestTier() tras construir la lista.
    input.checked = false;

    $('.volume-tier__title__primary').textContent = `${discount.min_items} ${(parseInt(discount.min_items) > 1 ? this.labelTypePlural : this.labelTypeSingular)}`;
    if (this.ITEMS_PER_BOX) {
      $('.volume-tier__title__secondary').textContent = (this.ITEMS_PER_BOX > 1) ? `(${this.ITEMS_PER_BOX} ${this.labelUnitsPer}${this.labelTypeSingular})` : '';
    }
    
    $('.volume-tier__price').textContent = price;
    if (!isNaN(unitPrice) && parseFloat(unitPrice) > 0) {
      $('.volume-tier__unit-price').textContent = `${unitPrice}€/Und.`;
    }
    $('.volume-tier__discount').textContent = `${this.labelDiscount} ${discount.discount_value}%`;

    if (discount.discount_value > 0) {
      $('.volume-tier__discount').classList.remove('hidden');
    }

    return node;
  }

  // Aplica IVA si el tipo de cliente lo requiere
  changePriceForType() {
    const ivaMultiplier = 1 + this.iva / 100;

    this.form.querySelectorAll('input[type="radio"]').forEach(input => {
      const priceRadio = parseFloat(input.dataset.price);
      const preunitRadio = parseFloat(input.dataset.preunit);
      const volumeTier = input.closest('.volume-tier');
      const priceElement = volumeTier.querySelector('.volume-tier__price');
      const unitPriceElement = volumeTier.querySelector('.volume-tier__unit-price');
      const discountElement = this.querySelector('.discount-value');

      if(discountElement) {
        this.discountElementSaved = discountElement.getAttribute('data-value');
      }

      if (this.customerType === 'private') {
        priceElement.textContent = `${truncateToDecimals(priceRadio * ivaMultiplier, 2)}€/${this.labelTypeSingular}`;
        unitPriceElement.textContent = `${truncateToDecimals(preunitRadio * ivaMultiplier, 2)}€/Und.`;
        if(discountElement) {
          discountElement.textContent = `${truncateToDecimals(this.discountElementSaved * ivaMultiplier, 2)}€`;
        }
      } else {
        priceElement.textContent = `${truncateToDecimals(priceRadio, 2)}€/${this.labelTypeSingular}`;
        unitPriceElement.textContent = `${truncateToDecimals(preunitRadio, 2)}€/Und.`;
        if(discountElement) {
          discountElement.textContent = `${truncateToDecimals(this.discountElementSaved, 2)}€`;
        }
      }
    });
  }

  // Calcula el precio con descuento
  calculateDiscountedPrice(discountPercentage) {
    return this.getPriceWithoutPercentage(this.price, discountPercentage);
  }

  // Obtiene el precio sin el porcentaje de descuento
  getPriceWithoutPercentage(price, discount) {
    //si el precio es 5.39 y el descuento es 10, el precio final debe ser 4.86 debemos redondear arriba porque asi lo hace shopify en el cart
    let finalPrice = Math.ceil((price - (price * (discount / 100))) * 100) / 100;
    return finalPrice;
  }
}

customElements.define('volume-selector', VolumeTierSelectorController);

class PricePerType extends HTMLElement {
  constructor() {
    super();  
  }

  connectedCallback(){
    const data = this.getAttribute('data-properties');
    const properties = JSON.parse(data);

    this.weight = properties.weight;
    this.weightUnit = properties.weightUnit;
    this.unitPerType = properties['unit-per-type'];
    this.price = properties.price;
    this.priceWithIVA = properties.priceWithIVA;
    this.unitType = properties.unitType;

    // En productos de volumen, el €/Kilo debe coincidir con el precio que muestra
    // <bundler-volume-price> (el "Desde" o el aplicado en carrito). Al re-renderizarse la
    // sección (stepper/añadir), el bvp está antes en el DOM y ya ha calculado su precio, así
    // que lo tomamos de él (evita mostrar el precio base y quedar descuadrado). En la carga
    // inicial, si el bvp aún no ha calculado, se muestra el base y el bvp lo actualiza luego.
    const wrap = this.closest('.c-product__price, .c-cp__price');
    const bvp = wrap && wrap.querySelector('bundler-volume-price');
    if (bvp && typeof bvp.currentPriceCents === 'function') {
      const shown = bvp.currentPriceCents();
      if (shown) {
        this.changePriceForType(shown.withIvaCents, shown.businessCents);
        return;
      }
    }

    this.calculatePrice();
  }

  changePriceForType(dataPreunit, dataPreunitBusiness){
    this.calculatePrice(dataPreunit, dataPreunitBusiness);
  }

  calculatePrice(dataPreunit = null, dataPreunitBusiness = null){
    if(dataPreunit && dataPreunitBusiness){
      this.price = dataPreunitBusiness;
      this.priceWithIVA = dataPreunit;
    }
  
    const weightPerGram =  (this.weightUnit === 'kg') ? this.weight * 1000 : this.weight; // si viene en kg, paso a g //si ya viene en gramos, lo dejo igual

    //price of centavos to euros
    const priceToEuro = this.price / 100;
    const priceToEuroWithIVA = this.priceWithIVA / 100;

    const pricePerKg =  priceToEuro / (weightPerGram / 1000);
    const pricePerKgWithIVA = priceToEuroWithIVA / (weightPerGram / 1000);

    this.insertData(pricePerKg, pricePerKgWithIVA);
  }

  insertData(price, priceIVA){
    if(price > 0) {
      this.querySelector('.price-without-iva').textContent = `${price.toFixed(2)}€/${this.unitType}`;
    }
    if(priceIVA > 0) {
      this.querySelector('.price-with-iva').textContent = `${priceIVA.toFixed(2)}€/${this.unitType}`;
    }
  }
}

customElements.define('price-per-type', PricePerType);